<div class="wab-time-picker">
  <div *ngIf="isLoading" class="wb-loader"> <span class="loading-animation"></span></div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="center-block">
        <div class="form-group">
          <label>Change Pickup Time</label>
          <select class="form-control custom-select" [(ngModel)]="selectedTime">
            <option *ngFor="let timepicker of timepickerList" [ngValue]="timepicker" [disabled]="!timepicker.isSelectable">
              {{timepicker.displayTimeRange}}</option>
          </select>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group">
              <button class="btn wb-btn-default" (click)="changeTime(selectedTime)">Change Time</button>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group">
              <button class="btn wb-btn-outline" (click)="cancel()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>